import React from 'react';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { routerHistory } from 'app/core/router/service';
import store from 'app/store';
import IdleTimer from 'app/common/components/Timer/IdleTimer';
import MainLayout from 'app/common/layouts/MainLayout';
import AppRoutes from './AppRoutes';
import { persistor } from './store/store';
import { PersistGate } from 'redux-persist/lib/integration/react';
import useComponentWillMount from './core/hooks/useComponentWillMount';

const App: React.FC = () => {
  /**
   * @description 於路由建置前，先檢查當前是否根路徑
   */
  useComponentWillMount(() => {
    if (window.location.pathname === '/' || window.location.pathname === '') {
      // 前端重新指派到「預設根路徑」
      window.location.assign('/insure');
    }
  });

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ConnectedRouter history={routerHistory}>
          <IdleTimer />
          <MainLayout>
            <AppRoutes />
          </MainLayout>
        </ConnectedRouter>
      </PersistGate>
    </Provider>
  );
};

export default App;
